// Decide whether an alpha mask represents a distinct cut-out-able object.
// Reuses the segmentation mask only — no second model.

const ALPHA_THRESHOLD = 128; // pixel counts as foreground above this opacity

export function assessStickerable(alpha: Uint8Array, width: number, height: number): boolean {
  const total = width * height;
  if (total === 0) return false;

  let fg = 0;
  let topEdge = 0, bottomEdge = 0, leftEdge = 0, rightEdge = 0;

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      if (alpha[y * width + x] > ALPHA_THRESHOLD) {
        fg++;
        if (y === 0) topEdge++;
        if (y === height - 1) bottomEdge++;
        if (x === 0) leftEdge++;
        if (x === width - 1) rightEdge++;
      }
    }
  }

  const coverage = fg / total;
  if (coverage < 0.12 || coverage > 0.88) return false; // too small or fills frame

  // Fraction of each edge that is foreground; bleeding across all four edges
  // means there is no clean background (e.g. a full-frame skin close-up).
  const edgeBleed = (count: number, len: number) => count / len > 0.6;
  const bleedingEdges =
    Number(edgeBleed(topEdge, width)) +
    Number(edgeBleed(bottomEdge, width)) +
    Number(edgeBleed(leftEdge, height)) +
    Number(edgeBleed(rightEdge, height));
  if (bleedingEdges >= 4) return false;

  return true;
}
